import React, { useEffect, useState } from 'react'
import MainContentWrapper from '../../Components/MainContentWrapper'
import { getRequestsIncentives } from '../../apis/BhuMeetTeams/CustomerSuccessEngineer/stores'
import Popup from '../../ReusableFunctions/Popup'
import TableView from '../../ReusableComponents/TableView/TableView'
import ChipInput from '../../ReusableComponents/ChipInput'
import { STATUS } from '../../appConstants'
import DatePicker from 'react-datepicker';
import calender from "../../assets/blueCalendar.svg";
import search from "../../assets/search.svg"
import ClearFilterButton from '../../ReusableComponents/TableView/ClearFilterButton'
import { useNavigate } from 'react-router-dom'
import { PDRL_ADMIN_ROUTES, PDRL_SUCCESS_ENGI_ROUTES } from '../../routes'
import {useLocation} from 'react-router-dom'

const ChipInputOptions=[
    {id:1,label:"All",onclick:()=>{}},
    {id:2,label:STATUS.PLACED,onclick:()=>{}},
    {id:2,label:STATUS.ACCEPTED,onclick:()=>{}},
    {id:9,label:STATUS.HOLD,onclick:()=>{}},
    {id:3,label:STATUS.OUT_FOR_SERVICE,onclick:()=>{}},
    {id:4,label:STATUS.INPROGRESS,onclick:()=>{}},
    {id:5,label:STATUS.COMPLETED,onclick:()=>{},},
    {id:6,label:STATUS.PAID,onclick:()=>{}},
    {id:7,label:STATUS.RESCHEDULED,onclick:()=>{},},
    {id:8,label:STATUS.CANCELLED,onclick:()=>{},}
]

export default function ViewRequestIncentives({
    store
}) {
    const [requestIncentives, setRequestIncentives] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [filters, setFilters] = useState(()=>{
        const savedFilters = localStorage.getItem('op_request_incentives_filters')
        if (savedFilters) {
            const parsesavedFilters = JSON.parse(savedFilters)
            return {...parsesavedFilters, searchQuery:""};  
        }
        return {
            tab:"All",
            pageNumber: 1,
            pageSize: 15,
            statuses:[],
            fromDate:null,
            toDate:null,
            searchQuery:"",
        }
        }
        )
    const [openDatePicker, setOpenDatePicker] = useState({
        fromDate:false,
        toDate:false
    })
    const navigate=useNavigate();
    const {pathname} =useLocation();


    const getRequestIncentivesFunc = async () => {
        try {
            setIsLoading(true);
            let requestIncentives = await getRequestsIncentives(store?.id, filters.pageNumber, filters.pageSize,filters.statuses,filters.fromDate,filters.toDate,filters.searchQuery);
            setRequestIncentives(requestIncentives);
            setIsLoading(false)
        } catch (err) {
            setIsLoading(false)
            Popup.alert("ERROR", "Something went wrong while getiing the requests incentives")
            console.log("err", err);
        }
    }


    const updateStatuesBasedOnType=(status)=>{
        let updatedStatus=[];
        switch (status) {
          case ChipInputOptions[1]?.label:
             updatedStatus=[STATUS.PLACED];
            break;
          case ChipInputOptions[2]?.label:
            updatedStatus=[STATUS.ACCEPTED];
            break;
          case ChipInputOptions[3]?.label:
            updatedStatus=[STATUS.HOLD];
            break;
          case ChipInputOptions[4]?.label:
            updatedStatus=[STATUS.OUT_FOR_SERVICE];
            break;
          case ChipInputOptions[5]?.label:
              updatedStatus=[STATUS.INPROGRESS];
              break;
         case ChipInputOptions[6]?.label:
                updatedStatus=[STATUS.COMPLETED];
                break;
          case ChipInputOptions[7]?.label:
                updatedStatus=[STATUS.PAID];
                break;
          case ChipInputOptions[8]?.label:
                    updatedStatus=[STATUS.RESCHEDULED];
                break;
          case ChipInputOptions[9]?.label:
             updatedStatus=[STATUS.CANCELLED];
            break;
            default:
              updatedStatus=[];
              break;
        }
        setFilters((prevFilters)=>({
            ...prevFilters,
            pageNumber:1,
            statuses:updatedStatus,
        }))
        
    }

    const setLocalStorageValues=()=>{
        localStorage.setItem("op_request_incentives_filters",JSON.stringify(filters));
    }

    useEffect(() => {
        setLocalStorageValues();
        getRequestIncentivesFunc()
    }, [filters])

    return (
        <MainContentWrapper  header={`
            Requests (${requestIncentives[0]?.request_count || 0})`} rightContent={
             <div style={{ position: "relative", height: "35px", width: "20%" }}>
                    <img src={search} alt='search icon' style={{ position: 'absolute', left: "20px", top: "10px" }} />
                    <input onChange={(e) => {
                        setFilters((prevFilters)=>({
                            ...prevFilters,
                            pageNumber:1,
                            searchQuery:e.target.value,
                        }))
                    }}
                        placeholder='Search request by req no,user name...'
                        style={{ width: "100%", height: '100%', borderRadius: "4px", border: "1px solid #BFC8D9", padding: "10px 10px 10px 60px", fontSize: "12px" }} 
                    />
            </div>
        }>
            <div className='w-full flex justify-between items-center '>
             {/* Tabs section */}
            <div className='chips-container'>
                {ChipInputOptions && ChipInputOptions.length > 0 &&
                    ChipInputOptions.map((chip) => (
                    <ChipInput
                        key={chip.id}
                        statusType={filters?.tab}
                        label={chip.label}
                        onFilterChange={(statusType) => {
                            updateStatuesBasedOnType(statusType);
                        setFilters((prevFilters)=>({
                            ...prevFilters,
                            tab:statusType,
                        }))
                        }}
                    />
                    ))}
            </div>
            {/* date filters section  */}
            <div  className='flex items-center mb-4'>
                    <div>
                      <ClearFilterButton  isVisible={filters.fromDate || filters.toDate} onClick={()=>{
                        setFilters((prevFilters)=>({
                            ...prevFilters,
                            fromDate:null,
                            toDate:null,
                        }))
                      }} />
                    </div>
            <div className='date_Filters '>
                    <div    
                        className="input-date "
                        style={{ display: "flex", fonrSize:"14px", alignItems: "center", cursor: "pointer", height: "34px", width: "150px", position: "relative", background: "transparent" }}
                        onClick={() => setOpenDatePicker((prev) => ({ ...prev, fromDate: true }))}
                    >
                        <DatePicker
                            onClickOutside={() => setOpenDatePicker((prev) => ({ ...prev, fromDate: false }))}
                            open={openDatePicker.fromDate}
                            placeholderText='From Date'
                            maxDate={filters?.toDate && new Date(filters?.toDate)}
                            readOnly
                            showMonthDropdown // 🔹 Allows selecting months when clicking on month
                             showYearDropdown 
                            dropdownMode="select" 
                            className="input-date-hidden"
                            selected={filters.fromDate ? new Date(filters.fromDate) : null}
                            onChange={date => {
                                if (date) {
                                    let fromDate = new Date(date).setHours(0, 0, 0, 0);
                                    fromDate = new Date(fromDate).toISOString();
                                    const updatedfilters = { ...filters, fromDate,pageNumber:1 };
                                    setFilters(updatedfilters);
                                  }
                            }}
                        />
                        <img src={calender} style={{ width: "18px", position: "absolute", right: "15px" }} />
                    </div>
                    <div className='text-xl font-thin'>-</div>
                    <div className="input-date  "
                        style={{ display: "flex", alignItems: "center", cursor: "pointer", height: "34px", width: "150px", position: "relative", background: "transparent" }}
                        onClick={() => {
                                setOpenDatePicker((prev) => ({ ...prev, toDate: true }))
                           
                        }}
                    >
                        <DatePicker
                            placeholderText='To Date'
                            onClickOutside={() => setOpenDatePicker((prev) => ({ ...prev, toDate: false }))}
                            open={openDatePicker.toDate}
                            disabled={!filters.fromDate}
                            minDate={filters?.fromDate && new Date(filters?.fromDate)}
                            style={{ zIndex: 1000 }} 
                            readOnly
                            showMonthDropdown // 🔹 Allows selecting months when clicking on month
                            showYearDropdown // 🔹 Allows selecting years when clicking on year
                            dropdownMode="select" 
                            className="input-date-hidden "
                            selected={filters.toDate ? new Date(filters.toDate) : null}
                            onChange={date => {
                                if (date) {
                                    let toDate = new Date(date).setHours(23, 59, 59, 999);
                                    toDate = new Date(toDate).toISOString();
                                    const updatedfilters = { ...filters, toDate,pageNumber:1 };
                                   setFilters(updatedfilters);
                                  }
                            }} />
                        <img src={calender} style={{ width: "18px", position: "absolute", right: "15px" }} />
                    </div>
                </div>
            </div>
            </div>
            <div style={{
                margin: "20px 0",
                height: "83%"
            }}>
                <TableView
                    showSrNo
                    loadingHeight={"500px"}
                    isLoading={isLoading}
                    onStateChange={async (changedState) => {
                        const { pageNumber } = changedState;
                        setFilters({ ...filters, pageNumber });
                    }}
                    onClickRow={(request) => { 
                        if(pathname===PDRL_SUCCESS_ENGI_ROUTES.CUSTSTOREDETAILS){
                            navigate(PDRL_SUCCESS_ENGI_ROUTES.REQUESTDETAILS,{ state: { request: {id: request.req_id} } })
                        }else  if(pathname===PDRL_ADMIN_ROUTES.STOREDETAILS) {
                            navigate(PDRL_ADMIN_ROUTES.OPERATIONS_REQUESTDETAILS,{ state: { request: {id: request.req_id} } })
                        }else {
                            return ;
                        }
                    }}
                    columns={[
                        { Header: "Request No", accessor: "req_number", width: "8%" },
                        { Header: "Request Status", accessor: "req_status", width: "8%" },
                        { Header: "Type", accessor: "type", width: "8%" },
                        { Header: "Note", accessor: "note", width: "15%" },
                        { Header: "Amount", accessor: "amount", width: "8%" },
                        { Header: "Date Added", accessor: "time", isDate: true, format: "dd/mm/yyyy", width: "8%" }
                    ]}
                    count={requestIncentives[0]?.request_count}
                    pageSize={filters.pageSize}
                    pageNumber={filters.pageNumber}
                    data={requestIncentives}
                    tableContainerHeight={"100%"}
                    hidePagination={false}
                    headerStyle={{ zIndex: 0 }}
                />
            </div>
        </MainContentWrapper>
    )
}
